import React from 'react';

export default function PendingTaskBadge({
	count,
	variant = 'count',
	tooltipPosition = 'left'
}) {
	if (!count || count <= 0) return null;

	const tooltipClass = `tooltip is-tooltip-${tooltipPosition}`;
	const tooltip = `${count} pending task${count > 1 ? 's' : ''}`;

	if (variant === 'dot') {
		return (
			<span
				className={`pending-task-badge dot ${tooltipClass}`}
				data-tooltip={tooltip}
			/>
		);
	}

	return (
		<span
			className={`pending-task-badge count ${tooltipClass}`}
			data-tooltip={tooltip}>
			{count > 99 ? '99+' : count}
		</span>
	);
}
